import { useMutation, useQuery } from "react-query";
import Api, { ImgAPI } from "../../apiclient/api";

import { UpdateRF } from "./ApiHandler";
// Reusable function for handling auth response
const handleAuth = async (data, customer, setCustomer, rf, navigate) => {
    if (data?.status === "Expire") {
        setCustomer?.({});
        await UpdateRF(rf);
        navigate('/login')
        return null;
    } else {
        if (data?.authorization) {
            setCustomer((prev) => ({
                ...prev,
                token: {
                    ...prev?.token,
                    authorization: data?.authorization,
                },
            }));
        }
    }

    if (data?.authorization && customer) {
        setCustomer(prev => ({
            ...prev,
            token: {
                ...prev.token,
                authorization: data.authorization,
            },
        }));
    }

    return data;
};

// GET request hook
export const useGetRequest = (endpoint, queryKey, headers = {}, extras = {}, params = {}) => {
    const { customer, setCustomer, rf, navigate } = extras;
    const normalizedQueryKey = Array.isArray(queryKey) ? queryKey : [queryKey];

    return useQuery({
        queryKey: [...normalizedQueryKey, params], // All changing parameters must be here
        queryFn: async () => {
            try {
                const response = await Api.get(endpoint, { headers, params });
                return handleAuth(response.data, customer, setCustomer, rf, navigate);
            } catch (err) {
                console.error(`GET ${endpoint}`, err);
                throw err;
            }
        },
        enabled: Boolean(endpoint),
        keepPreviousData: true,
        staleTime: 30 * 1000,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
    });
};

// POST request hook
export const usePostRequest = (endpoint, imgApi = false, headers = {}, extras = {}) => {
    const { customer, setCustomer, rf, navigate } = extras;

    return useMutation(
        async (payload) => {
            if (!endpoint) {
                return;
            }
            const api = imgApi ? ImgAPI : Api;
            if (extras?.customer) {
                payload.customer_id = extras?.customer?.customer_details?.customer_id
                payload.user_login_id = extras?.customer?.customer_details?.id
            }
            const response = await api.post(endpoint, payload, headers);
            return await handleAuth(response.data, customer, setCustomer, rf, navigate);
        }
    );
};